// utils/translateBatch.js
const TARGET_LANG = "en-US";

export const translateBatch = async ({ texts, toWhatLang, fromWhatLang }) => {
  if (!texts?.length) return [];
  try {
    const res = await fetch(
      "https://us-central1-menuapp-4c413.cloudfunctions.net/tripadvisor/translateWithDeepL",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          texts,
          toLang: toWhatLang ?? TARGET_LANG,
          fromLang: fromWhatLang, // sendes alltid inn eksplisitt nå
        }),
      },
    );
    const json = await res.json();
    return json.text ?? texts;
  } catch (err) {
    console.error("Batch translate error:", err);
    return texts;
  }
};